import { Component, OnInit } from '@angular/core';
import { MessageService } from 'src/app/core/services/broadcast/message-service';

@Component({
  selector: 'app-error-messages',
  templateUrl: './error-messages.component.html',
  styleUrls: ['./error-messages.component.scss']
})
export class ErrorMessagesComponent implements OnInit {
  messageService: MessageService;

  constructor(msgService: MessageService) { 
    this.messageService = msgService;
  }

  ngOnInit(): void {
  }

  closeNotices():void{
    this.messageService.clearExceptionMessages();
  }

}
